import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { MovieLoadingComponent } from '@usheru-hff/ui/movie-detail-page';
import { Movie } from '@usheru-hff/shared/domain';
import { ImgModalDirective, SharedUtilsModule } from '@usheru-hff/shared/utils';
import { ImageService, SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';

/**
 * Component to display the trDescription from a movie.
 *
 * //TODO barbeitoalex propostal - subscribe to current language to update the translate pipes
 */
@Component({
  selector: 'ush-movie-synopsis',
  templateUrl: './movie-synopsis.component.html',
  styleUrls: ['./movie-synopsis.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, SharedUtilsModule]
})
export class MovieSynopsisComponent implements MovieLoadingComponent {
  private readonly imageService = inject(ImageService);
  /**
   * @docsNotRequired
   */
  readonly movie = input<Movie | null>(null);
  readonly isLoadingData = input(false);

  portraitPlaceholder!: string;

  constructor() {
    this.portraitPlaceholder = this.imageService.portraitPlaceholder;
  }
}
